import {ChangeDetectorRef, Component, Input, ViewChild} from '@angular/core';
import { ModalComponent, TableModule } from 'remarketing-ui-components-lib';
import {
  ServiceFeeTier,
  ServiceFeeTierHelper
} from '../../../models/service-fee-schedule-tier.model';
import {
  AuctionFeeSchedule,
  AuctionFeeScheduleRange,
  Organization,
} from 'remarketing-angular-library';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { CdkTableModule } from '@angular/cdk/table';
import { CurrencyPipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-service-fee-schedule-modal',
    templateUrl: './service-fee-schedule-modal.component.html',
    styleUrls: ['./service-fee-schedule-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, TableModule, CdkTableModule, CurrencyPipe]
})
export class ServiceFeeScheduleModalComponent extends SaComponent{

  @ViewChild(ModalComponent) modal: ModalComponent;
  @Input() modalId = 'Service-Fee-Schedule';
  @Input() auctionFeeSchedule: AuctionFeeSchedule;
  sortedFeeTiers: ServiceFeeTierHelper[] = [];
  maxPriceAmount = 0;
  maxFeeAmount = 0;
  maxFeePercentAmount = 0;
  maxFeeTier: ServiceFeeTierHelper;
  auctionFeeScheduleName: string;
  organization: Organization;

  datasource: ServiceFeeTier[] = [];

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private store: Store
  ) {
    super();
  }

  ngOnInit() {
    this.store
      .select(_state => _state.org.organization)
      .pipe(takeUntil(this.destroyed$)).
    subscribe(organization => this.organization = organization);

  }

  closeModal(){
    this.sortedFeeTiers = [];
    this.modal.close();
  }

  show() {
    this.auctionFeeScheduleName = this.auctionFeeSchedule.auctionFeeScheduleName;
    this.sortAuctionFeeSchedule();
    this.datasource = this.generateDatasource();
    this.changeDetectorRef.markForCheck();
    this.modal.show();
  }

  getFeeAmount(feeRange: AuctionFeeScheduleRange): number{
    if(feeRange.auctionFeeAmount){
      return feeRange.auctionFeeAmount;
    }
    return 0;
  }

  getFeePercent(feeRange: AuctionFeeScheduleRange): number{
    if(feeRange.auctionFeePercentage){
      return feeRange.auctionFeePercentage;
    }
    return 0;
  }

  sortAuctionFeeSchedule(){
    this.sortedFeeTiers = [];
    this.auctionFeeSchedule.auctionFeeScheduleRanges.forEach(feeRange => {
      if(feeRange.maximumOpeningPriceAmount){
        const feeTier = {
          minimum: feeRange.minimumOpeningPriceAmount,
          maximum: feeRange.maximumOpeningPriceAmount,
          feeAmount: this.getFeeAmount(feeRange),
          feePercent: this.getFeePercent(feeRange)
        };
        this.sortedFeeTiers.push(feeTier);
        if(feeTier.maximum > this.maxPriceAmount){ // determine highest tier amount
          this.maxPriceAmount = feeTier.maximum;
        }
      }
      else {  // no maximum indicate the final tier
        this.maxFeeAmount = this.getFeeAmount(feeRange);
        this.maxFeePercentAmount = this.getFeePercent(feeRange);
      }
    });

    this.maxFeeTier = {minimum: 0, maximum: this.maxPriceAmount, feeAmount: this.maxFeeAmount, feePercent: this.maxFeePercentAmount};
    this.sortedFeeTiers.sort((a,b) => (a.minimum > b.minimum) ? 1 : -1);
  }

  generateDatasource(): ServiceFeeTier[]{
    const data = [];
    const internationalNumberFormat = new Intl.NumberFormat('en-US');
    // format fee tiers
    this.sortedFeeTiers.forEach(helper => {
      // format min and max to string
      const rangeText = `$${internationalNumberFormat.format(helper.minimum)} - $${internationalNumberFormat.format(helper.maximum)}`;
      // format fee amount
      const feeAmount = this.getFeeDisplay(helper.feeAmount, helper.feePercent);
      data.push({openingPrice: rangeText, feeAmount: feeAmount});
    });
    // format final tier
    const maxFee = this.getFeeDisplay(this.maxFeeAmount, this.maxFeePercentAmount);
    data.push({openingPrice: '', feeAmount: maxFee});
    return data;
  }

  getFeeDisplay(feeAmount: number, feePercent: number): string{
    const internationalNumberFormat = new Intl.NumberFormat('en-US');
    if(feeAmount > 0 && feePercent === 0){ // only fee amount
      return `$${internationalNumberFormat.format(feeAmount)}`;
    } else if(feePercent > 0 && feeAmount === 0){ // only fee percent
      return `${internationalNumberFormat.format(feePercent)}%`;
    } else if (feeAmount > 0 && feePercent > 0){ //  amount && percent
      return `$${internationalNumberFormat.format(feeAmount)} + ${internationalNumberFormat.format(feePercent)}%`;
    }
    return '$0';
  }

}
